var render, staticRenderFns
import script from "./CompanyBusinessCard.vue?vue&type=script&lang=js&"
export * from "./CompanyBusinessCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba45425e')) {
      api.createRecord('ba45425e', component.options)
    } else {
      api.reload('ba45425e', component.options)
    }
    
  }
}
component.options.__file = "module/Vrcci/Company/resources/vue/CompanyBusinessCard.vue"
export default component.exports